import { RegisterItem } from '@wearejh/m2-pwa-engine/lib/types';

import { metaStartCheckout } from './epics/startCheckout.epic';

export function metaRegister(): RegisterItem {
    return {
        epics: [metaStartCheckout],
        reducers: {},
        name: 'meta',
    };
}
